export const isValidNumber = (value: string) =>
  value !== "" && !isNaN(Number(value));

export const isValidText = (value: string) =>
  isNaN(Number(value)) && value !== "";
